/**
 * A round's status in a cached thread detail (final fix wave, I2).
 *
 * The store forgets the rounds closed on this client at every thread switch
 * (`closedClarifyRounds` is thread-scoped). Within the thread query's
 * staleTime, switching back serves the cached detail — where the round a user
 * just answered or ✕'d is still `open` — so it would re-dock. ChatRoute writes
 * the status the server now holds into that cache as the round closes (and
 * back to `open` if the server reopened it), via `setQueriesData`.
 */
import type { ThreadMessage } from "@/features/chat/MessageList";

import type { ClarifyStatus } from "./types";

/** `detail` with `roundId`'s status set; the same object when nothing changes. */
export function withRoundStatus<T extends { messages: ThreadMessage[] }>(
  detail: T | undefined,
  roundId: string,
  status: ClarifyStatus,
): T | undefined {
  if (detail === undefined) return undefined;
  let changed = false;
  const messages = detail.messages.map((message) => {
    const round = message.clarify_round;
    if (round === undefined || round === null || round.round_id !== roundId || round.status === status) {
      return message;
    }
    changed = true;
    return { ...message, clarify_round: { ...round, status } };
  });
  return changed ? { ...detail, messages } : detail;
}
